'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$00247 from "./presto.-Two-Factor-Auth-View$$anon$7.js";
import * as $j_presto$002etypes$0024$002dEmail$0024 from "./presto.types$-Email$.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$6(outer) {
  this.bGq = null;
  this.bGo = null;
  this.bGp = false;
  this.bGm = null;
  this.bGn = false;
  this.bGr = false;
  this.bGs = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.bGq = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_TwoFactorAuthView$$anon$6 as $c_Lpresto_TwoFactorAuthView$$anon$6 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$6.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$6;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$6() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$6 as $h_Lpresto_TwoFactorAuthView$$anon$6 };
$h_Lpresto_TwoFactorAuthView$$anon$6.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.bGq;
});
$p.t = (function() {
  if ((!this.bGp)) {
    this.bGo = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("seeds", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("invites", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bGp = true;
  }
  return this.bGo;
});
$p.ag = (function() {
  if ((!this.bGn)) {
    this.bGm = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Encoder$$anon$25(new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$00247.$c_Lpresto_TwoFactorAuthView$$anon$7()), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Encoder$$anon$25($j_presto$002etypes$0024$002dEmail$0024.$m_Lpresto_types$Email$().ph()), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bGn = true;
  }
  return this.bGm;
});
$p.v = (function() {
  if ((!this.bGs)) {
    this.bGr = false;
    this.bGs = true;
  }
  return this.bGr;
});
$p.ae = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_TwoFactorAuthView$$anon$6 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$6, "presto.TwoFactorAuthView$$anon$6", ({
  T6: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$6 as $d_Lpresto_TwoFactorAuthView$$anon$6 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$6.js.map
